
import { defineComponent, watch, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ApiPaymentResponse } from '@/contracts/api/ResponseContracts'
import { PaymentPrepareItem } from '@/contracts/api/RequestContracts'
import { BasketItem } from '@/contracts/store/BasketContracts'
import { axiosPostPayment } from '@/composables/api'

export default defineComponent({
    name: 'Pay',
    setup()
{
        const router = useRouter()
        const store = useStore()
        const isAuthenticated = store.getters['auth/isAuthenticated']

        const basketItems = computed(() => store.getters['basket/getBasket'])

        const makePayment = () =>
{
            if(basketItems.value.length === 0)
{
                router.push({ name: 'Basket' })
                return
            }

            // Build one entry per basket item. Already-digitised grants carry a
            // real Nuxeo uid and pass straight through; a calendar order (a will
            // not yet digitised) has no uid, so we send the deceased's details
            // and the proxy creates the grant server-side via
            // RequestNewWillOperation. Customer identity/email are deliberately
            // NOT sent — the proxy derives them from the verified auth token
            // (§3.11 / register Q34), so they cannot be spoofed.
            const items: Array<PaymentPrepareItem> = basketItems.value.map((item: BasketItem) =>
                item.uid
                    ? { uid: item.uid }
                    : {
                        caldoc_uid: item.caldoc_uid as string,
                        firstnames: item['hmctsgrant:firstnames'],
                        surname: item['hmctsgrant:surname'],
                        dateofprobate: item['hmctsgrant:dateofprobate'],
                        dateofdeath: item['hmctsgrant:dateofdeath'],
                        registryofficename: item['hmctsgrant:registryofficename'],
                        folionumber: item['hmctsgrant:folionumber']
                    })

            const paymentData = axiosPostPayment('/payment/prepare', {
                items: items,
                CURRENCY: 'GBP'
            })

            watch(paymentData, (response: ApiPaymentResponse) =>
{
                if(response.status === 200 && response.redirectURL)
{
                    // Reference stored for the /payment/status check on the success page
                    store.commit('basket/setTransactionReference', response.transactionReference)
                    window.location.href = response.redirectURL
                }
 else
{
                    store.commit('errors/setNuxeoErrors', {
                        message: response.message || 'Payment service unavailable.'
                    })
                    router.push({ name: 'Basket', hash: '#error-summary-container' })
                }
            })
        }

        onMounted(() =>
{
            if(isAuthenticated)
{
                makePayment()
            }
        })

        return { isAuthenticated }
    }
})
